import styled from 'styled-components'

import { useMediaQueryContext } from 'contexts/MediaQueryContext'

import { LargeVideo } from '../../../components/branding/VideoBanner'

const Outer = styled.div`
  overflow: hidden;
  border-radius: 6px;
`

type VideoProps = {
  playbackId?: string
}

const Video = ({ playbackId }: VideoProps) => {
  const { md: largerThanMd } = useMediaQueryContext()
  const height = largerThanMd ? '700px' : '400px'

  return (
    <Outer>
      <LargeVideo playbackId={playbackId} height={height} />
    </Outer>
  )
}

export default Video
